/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedAuditLogEmailSMSSchema } from '../models/PagedAuditLogEmailSMSSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuditEmailSmsApi {
    /**
     * Get Audit Email Sms Log
     * Get email sms audit log of company.
     * @returns PagedAuditLogEmailSMSSchema OK
     * @throws ApiError
     */
    public static auditEmailSmsGetAuditEmailSmsLogGet({
        search,
        dateFrom,
        dateTo,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        dateFrom?: (string | null),
        dateTo?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedAuditLogEmailSMSSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/audit-email-sms/',
            query: {
                'search': search,
                'date_from': dateFrom,
                'date_to': dateTo,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
